export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';
export const ARBITRATOR_START = 'ARBITRATOR_START';
export const ARBITRATOR_FAIL = 'ARBITRATOR_FAIL';
export const ARBITRATOR_SUCCESS = 'ARBITRATOR_SUCCESS';
export const SET_ARBITRATOR_START = 'SET_ARBITRATOR_START';
export const SET_ARBITRATOR_FAIL = 'SET_ARBITRATOR_FAIL';
export const SET_ARBITRATOR_SUCCESS = 'SET_ARBITRATOR_SUCCESS';
export const VERIFY_START = 'VERIFY_START';
export const VERIFY_SUCCESS = 'VERIFY_SUCCESS';
export const VERIFY_FAIL = 'VERIFY_FAIL';
export const SMS_START = 'SMS_START';
export const SMS_SUCCESS = 'SMS_SUCCESS';
export const SMS_FAIL = 'SMS_FAIL';
export const AUTH_SUCCESS_ON_TRY_LOGIN = 'AUTH_SUCCESS_ON_TRY_LOGIN';
export const Add_FILE = 'Add_FILE';
export const REMOVE_FILE = 'REMOVE_FILE';
export const UPLOAD_FILE_START = 'UPLOAD_FILE_START';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_ERROR = 'UPLOAD_FILE_ERROR';
export const CASEINFO_SUCCESS = 'CASEINFO_SUCCESS';
export const CASEINFO_START = 'CASEINFO_START';
export const CASEINFO_FAIL = 'CASEINFO_FAIL';
export const SET_CASE_INFORMATION_USERTYPE = 'SET_CASE_INFORMATION_USERTYPE';
export const ONBOARDING_STEP_COMPLETE_START = 'ONBOARDING_STEP_COMPLETE_START';
export const ONBOARDING_STEP_COMPLETE_SUCCESS = 'ONBOARDING_STEP_COMPLETE_SUCCESS';
export const ONBOARDING_STEP_COMPLETE_FAIL = 'ONBOARDING_STEP_COMPLETE_FAIL';
export const START_UPLOAD_SIGNATURE = 'START_UPLOAD_SIGNATURE';
export const FAIL_UPLOAD_SIGNATURE = 'FAIL_UPLOAD_SIGNATURE';
export const SUCCESS_UPLOAD_SIGNATURE = 'SUCCESS_UPLOAD_SIGNATURE';

export const START_DELIVER_AWARD = 'START_DELIVER_AWARD';
export const FAIL_DELIVER_AWARD = 'FAIL_DELIVER_AWARD';
export const SUCCESS_DELIVER_AWARD = 'SUCCESS_DELIVER_AWARD';

export const START_USER_INFORMATION = 'START_USER_INFORMATION';
export const FAIL_USER_INFORMATION = 'FAIL_USER_INFORMATION';
export const SUCCESS_USER_INFORMATION = 'SUCCESS_USER_INFORMATION';

export const GET_ALL_CHAT_MSGS = 'GET_ALL_CHAT_MSGS';
export const ADD_Chat_MSG = 'ADD_Chat_MSG';
export const Error_ADD_Chat_MSG = 'Error_ADD_Chat_MSG';
export const ERROR_GET_ALL_CHAT_MSG = 'ERROR_GET_ALL_CHAT_MSG';

export const GET_ALL_CHAT_MSGS_EnquirySettlement = 'GET_ALL_CHAT_MSGS_EnquirySettlement';
export const ADD_Chat_MSG_EnquirySettlement = 'ADD_Chat_MSG_EnquirySettlement';
export const Error_ADD_Chat_MSG_EnquirySettlement = 'Error_ADD_Chat_MSG_EnquirySettlement';
export const ERROR_GET_ALL_CHAT_MSG_EnquirySettlement = 'ERROR_GET_ALL_CHAT_MSG_EnquirySettlement';

export const SET_ADD_OFFER_ERROR = 'SET_ADD_OFFER_ERROR';
export const SET_ADD_OFFER_NOERROR = 'SET_ADD_OFFER_NOERROR';
export const SET_ADD_OFFER_ACCEPTED = 'SET_ADD_OFFER_ACCEPTED';
export const UPDATE_USER_INFO_START = 'UPDATE_USER_INFO_START';
export const UPDATE_USER_INFO_SUCCESS = 'UPDATE_USER_INFO_SUCCESS';
export const UPDATE_USER_INFO_ERROR = 'UPDATE_USER_INFO_ERROR';
export const SET_FALSE_UPLOADED_FILE_SUCCESS= 'SET_FALSE_UPLOADED_FILE_SUCCESS';

export const RECOVER_PASSWORD_SUCCESS = 'RECOVER_PASSWORD_SUCCESS';
export const RECOVER_PASSWORD_FAIL = 'RECOVER_PASSWORD_FAIL';

export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD_FAIL';

export const ARBI_AGREEMENT_SUCCESS = 'ARBI_AGREEMENT_SUCCESS';
export const ARBI_AGREEMENT_FAIL = 'ARBI_AGREEMENT_FAIL';

export const ARBI_GETALLAGREEMENT_SUCCESS = 'ARBI_GETALLAGREEMENT_SUCCESS';
export const ARBI_GETALLAGREEMENT_FAIL = 'ARBI_GETALLAGREEMENT_FAIL';
export const ARBI_GETALLAGREEMENT_LOADING = 'ARBI_GETALLAGREEMENT_LOADING';
export const ARBI_GETALLAGREEMENT_NOTLOADING = 'ARBI_GETALLAGREEMENT_NOTLOADING';

export const ARBITRATOR_ACCEPT_REJECT_SUCCESS = 'ARBITRATOR_ACCEPT_REJECT_SUCCESS';
export const ARBITRATOR_ACCEPT_REJECT_ERROR = 'ARBITRATOR_ACCEPT_REJECT_ERROR';
export const ARBITRATOR_ACCEPT_REJECT_FALSE = 'ARBITRATOR_ACCEPT_REJECT_FALSE';

export const ADMIN_ACCEPT_REJECT_SUCCESS = 'ADMIN_ACCEPT_REJECT_SUCCESS';
export const ADMIN_ACCEPT_REJECT_ERROR = 'ADMIN_ACCEPT_REJECT_ERROR';
export const ADMIN_ACCEPT_REJECT_FALSE = 'ADMIN_ACCEPT_REJECT_FALSE';

export const SCHEDULE_MEETING_FAIL = 'SCHEDULE_MEETING_FAIL';
export const SCHEDULE_MEETING_TRUE = 'SCHEDULE_MEETING_TRUE';





